import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import { Box } from 'system';
import { HTMLContent } from 'src/components/HTMLContent';
import { Subheading } from 'src/components/Subheading';
export const AttributeList = _ref => {
  let {
    children,
    nameColor = 'red.40'
  } = _ref,
      props = _objectWithoutProperties(_ref, ["children", "nameColor"]);

  return React.createElement(Box, Object.assign({
    as: "table",
    display: "table",
    mbScale: "-t",
    width: 1
  }, props), React.Children.map(children, child => child && React.cloneElement(child, {
    nameColor
  })));
};

AttributeList.Attribute = _ref2 => {
  let {
    children,
    textHTML,
    name,
    nameColor
  } = _ref2,
      props = _objectWithoutProperties(_ref2, ["children", "textHTML", "name", "nameColor"]);

  return React.createElement(Box, Object.assign({
    as: "tr",
    display: "table-row"
  }, props), React.createElement(Box, {
    as: "td",
    display: "table-cell",
    pbScale: "t-",
    prScale: "m"
  }, React.createElement(Subheading, {
    as: "dt",
    color: nameColor
  }, name)), React.createElement(Box, {
    as: "td",
    display: "table-cell",
    pbScale: "t-",
    width: 3 / 4
  }, React.createElement(Box, {
    as: "dd"
  }, children || textHTML && React.createElement(HTMLContent, {
    html: textHTML,
    lineHeight: "wide"
  }))));
};